import get from 'lodash.get';
import ProductService from './ProductService';
import StandardService from './StandardService';
import ProductType from '../constants/ProductType';
import envList from '../constants/envList';
import RtMaxService from './rtMaxService';

class RtPlusService {
  static getProducts(source, preselect, isolationValue, env = envList.CA.path, r) {
    switch (env) {
      case envList.CA.path: {
        let entreChevrons = ProductService.getEntreChevronsOptions(source);
        let sousChevrons = ProductService.getSousChevronsOptions(source);
        const suspentes = ProductService.getSuspentesOptions(source);
        const manchons = ProductService.getManchonOptions(source);
        const adhesifs = ProductService.getAdhesifOptions(source);
        const mastics = ProductService.getMasticOptions(source);

        // create copie off all object, because they have the same reference
        entreChevrons = entreChevrons.map(entreChevron => JSON.parse(JSON.stringify(entreChevron)));

        // create copie off all object, because they have the same reference
        sousChevrons = sousChevrons.map(sousChevron => JSON.parse(JSON.stringify(sousChevron)));

        const adhesifPrice = adhesifs[0].value.price;
        const adhesifRTPlusXL = adhesifs[1].value.price;
        const adhesifRTPlus = adhesifs[0];

        const masticPrice = mastics[0].value.price;
        const manchonsPrice = manchons[0].value.price;

        const sousChevronsRtplusFiltered = sousChevrons.filter(
          x => x.value.workstype.indexOf('3') > -1
        );
        const entreChevronsRtPlusFiltered = entreChevrons.filter(
          entreChevron => entreChevron.value.workstype.indexOf('3') > -1
        );

        // Filter on suspentes
        const suspentesRtplus = suspentes.filter(
          x => x.value.workstype.indexOf('3') > -1
        );

        const entreChevronsItemId = get(
          preselect.find(
            i => (i.solution_id === 3 && i.entreousouschevron === 1)
        && entreChevronsRtPlusFiltered.find(
          product => product.key === i.product_id
        )
          ),
          'product_id',
          null
        );

        const adhesifItemId = get(
          preselect.find(
            i => (i.solution_id === 3 && i.type_id === 5)
            && adhesifs.find(
              adhesif => adhesif.key === i.product_id
            )
          ),
          'product_id',
          null
        );

        const sousChevronItemId = get(
          preselect.find(
            i => (i.solution_id === 3 && i.entreousouschevron === 2)
            && sousChevronsRtplusFiltered.find(
              product => product.key === i.product_id
            )
          ),
          'product_id',
          null
        );

        const suspentesId = get(
          preselect.find(
            i => (i.solution_id === 3 && i.type_id === 5)
          ),
          'product_id',
          null,
        );

        const entreChevronsItem = get(entreChevrons.find(
          productOption => productOption.key === entreChevronsItemId
        ), 'value', null);

        let sousChevronsItem = get(sousChevrons.find(
          productOption => productOption.key === 72
        ), 'value', null);

        if (!sousChevronsItem) {
          sousChevronsItem = get(sousChevrons.find(
            productOption => productOption.key === sousChevronItemId
          ), 'value', null);
        }

        const suspentesItem = get(suspentesRtplus.find(
          suspente => suspente.key === suspentesId
        ), 'value', null);

        const pathLink = get(entreChevrons.find(
          productOption => productOption.key === entreChevronsItemId
        ), 'value', null);

        const selectedAdhesif = get(
          adhesifs.find(
            adhesif => adhesif.key === adhesifItemId
          ),
          'value',
          null
        );

        return {
          adhesifPrice,
          adhesifRTPlusXL,
          adhesifs: adhesifRTPlus,
          entreChevrons,
          entreChevronsItem,
          entreChevronsRtPlusFiltered,
          manchons,
          manchonsPrice,
          masticPrice,
          mastics,
          pathLink,
          selectedAdhesif,
          sousChevrons,
          sousChevronsItem,
          sousChevronsRtplusFiltered,
          suspentes,
          suspentesItem,
          suspentesRtplus,
        };
      }
      case envList.IME.path:
        return RtMaxService.getProducts(source, preselect, isolationValue, env, '3');
      case envList.CP.path: {
        const blownInsulator = ProductService.getInsulatorBlown(source);
        const suspentes = ProductService.getSuspentesOptions(source);
        const adhesives = ProductService.getAdhesifOptions(source);
        const membranes = ProductService.getMembraneOptions(source);
        const mastics = ProductService.getMasticOptions(source);
        const selectedInsulator = get(
          blownInsulator.find(
            insulator => Number(insulator.value.resistance) === Math.ceil(r)
              && preselect.find(
                pre => pre.product_id === insulator.key && pre.solution_id === 10
              )
          ),
          'value',
          null,
        );

        const selectedSuspentes = get(
          suspentes.find(
            sus => (
              sus.value.workstype.includes('3')
              && preselect.find(
                pre => pre.product_id === sus.key && pre.solution_id === 10
              )
            )
          ),
          'value',
          null,
        );

        const selectedMembrane = get(
          membranes.find(
            membrane => (
              membrane.value.workstype.includes('3')
              && preselect.find(
                pre => pre.product_id === membrane.key && pre.solution_id === 10
              )
            )
          ),
          'value',
          null,
        );

        const selectedAdhesive = get(
          adhesives.find(
            adhesive => (
              adhesive.value.workstype.includes('3')
              && preselect.find(
                pre => pre.product_id === adhesive.key && pre.solution_id === 10
              )
            )
          ),
          'value',
          null,
        );

        const selectedMastic = get(
          mastics.find(
            mastic => (
              mastic.value.workstype.includes('3')
              && preselect.find(
                pre => pre.product_id === mastic.key && pre.solution_id === 10
              )
            )
          ),
          'value',
          null,
        );

        return {
          adhesives,
          mastics,
          membranes,
          selectedAdhesive,
          selectedMastic,
          selectedMembrane,
          selectedSuspentes,
          suspentes,
          insulators: blownInsulator,
          selectedInsulator,
        };
      }
      default:
        break;
    }
  }


  static calculateCost(products, isolationValue, env = envList.CA.path) {
    let costs = {};
    products.forEach((product) => {
      const { productData: data } = product;
      switch (product.type) {
        case ProductType.MANCHON:
          costs.manchon = {
            tarifSurfaceManchon: data.quantity * data.price,
          };
          break;
        case ProductType.MEMBRANE: {
          const adhesiveCost = StandardService.calculateCost(products, isolationValue, env);
          const { membrane } = adhesiveCost;

          if (env === envList.CP.path) {
            membrane.costMem = membrane.nbRollMem * (data && data.price);
          }

          costs.membrane = membrane;
          break;
        }
        default:
          costs = {
            ...costs,
            ...StandardService.calculateCost(products, isolationValue, env),
          };
          break;
      }
    });

    return costs;
  }
}

export default RtPlusService;



// WEBPACK FOOTER //
// ./src/services/rtPlusService.js